import { Users, Syringe, Activity, Heart } from "lucide-react";

const TrustStrip = () => {
  const stats = [
    { icon: "🐐", label: "Animals under care", value: "229", accent: "primary" },
    { icon: Users, label: "Happy customers", value: "23", accent: "primary" },
    { icon: Syringe, label: "Vaccinations on time", value: "100%", accent: "primary" },
    { icon: Activity, label: "Live tracking access", value: "24/7", accent: "primary" },
  ];

  return (
    <section className="py-6 sm:py-8 bg-primary/5 border-y border-primary/10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 max-w-5xl mx-auto">
          {stats.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                className="flex items-center gap-3 sm:gap-4 p-3 sm:p-4 rounded-xl bg-white border border-border hover:border-primary/40 hover:shadow-md transition-all"
              >
                <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  {typeof Icon === "string" ? (
                    <span className="text-xl sm:text-2xl">{Icon}</span>
                  ) : (
                    <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-primary" />
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xl sm:text-2xl font-extrabold text-foreground leading-none">
                    {s.value}
                  </p>
                  <p className="text-[11px] sm:text-xs text-muted-foreground mt-1 leading-tight">
                    {s.label}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        <div className="text-center mt-4 sm:mt-6">
          <p className="text-xs sm:text-sm text-muted-foreground inline-flex items-center gap-2">
            <Heart className="w-3.5 h-3.5 text-red-500 fill-red-500" />
            Real numbers from our farm.{" "}
            <span className="font-semibold text-foreground">Not marketing claims.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
